import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { genfunction } from 'helpers'

const useStyles = makeStyles(theme => ({
    MenuImage: {
        width: 100,
        height: 100,
        maxWidth: 100,
        maxHeight: 100
    },
    MenuBox: {
        cursor: "pointer"
    }
}));

const MenuItem = (props) => {

    const classes = useStyles();
    const { Menu } = props;

    const onClickMenuHandler = (menuName) => {
        props.history.push('/ordersubmenu/' + menuName);
    }

    return (
        <Grid container spacing={1} key={Menu.MenuName} item xs={12} className={classes.MenuBox} onClick={() => { onClickMenuHandler(Menu.MenuName); }}>
            <Grid item xs={5}>
                {Menu.MenuImageURL && Menu.MenuImageURL != "" ?
                    <img
                        className={classes.MenuImage}
                        width={'100%'}
                        height={'100%'}
                        alt="Logo"
                        src={Menu.MenuImageURL && Menu.MenuImageURL != "" ? genfunction.replaceEscapeCharacters(Menu.MenuImageURL) : process.env.PUBLIC_URL + "/images/foodorder-placeholder.png"} /> : <div className={classes.MenuImage}></div>}
            </Grid>
            <Grid item xs={7} style={{ alignSelf: "center" }}>
                <Typography style={{ display: "inline" }} variant="subtitle1">{Menu.MenuName}</Typography>
            </Grid>
            <Grid item xs={12}>
                <hr></hr>
            </Grid>
        </Grid>
    );
};

export default MenuItem;